
import { MultiPolygon, PolyCoords } from '../../../shared/types/MapShapes';
import { Component, Vue, Prop, Emit, Inject } from 'vue-property-decorator';
import Button from '../../../core/components/Generics/Button.vue';
import RequestDialog from '../../../core/components/Generics/RequestDialog.vue';
import { ItemPort } from '../../../core/api/ports';
import { InjectionKey } from '../../../core/injection-keys';
import { ColorsList } from '../../../core/utils/type-colors';
@Component({
  components: {
    Button,
    RequestDialog
  }
})
export default class SendItemDialog extends Vue {
  @Inject(InjectionKey.ItemApi) readonly itemApi!: ItemPort;
  @Prop({ default: () => [] }) polygonCoords!: PolyCoords;
  @Prop({ default: '' }) submitTooltip: string;
  @Prop({default: false}) isReadOnly: boolean;
  @Prop({default: false}) polygonReallyModified: boolean;
  orangeColor: string = ColorsList.mid_orange;
  logoSmartwayWhite: string = require('../../../../assets/logo_smartway_blue.png');
  smartwayUrl: string = 'https://onsmartway.com';
  dialog = false;
  loading = false;
  success = false;
  error = false;
  dialogTitle = 'Guardando...';
  successMessage = 'Guardado correctamente.';
  errorMessage = 'Ocurrió un error.';
  errorDescription: string = '';

  existsCoordsForPolygon() {
    return this.polygonCoords && this.polygonCoords.length > 0;
  }

  get canSubmit(){
    return this.submitTooltip === '';
  }

  clickSaveItem() {
    if(this.isReadOnly){
      this.showMessage('Usted no cuenta con los permisos necesarios para modificar el item', 'error')
      return
    }

    if(!this.canSubmit){
      this.showMessage(this.submitTooltip, 'error');
      return;
    }
    
    return this.sendItemToBackend();
  }

  @Emit()
  redirectAction(newUrl: string | null){}

  async sendItemToBackend() {
    this.dialog = true;
    this.loading = true;
    this.success = false;
    this.error = false;
    this.dialogTitle = 'Guardando...';
    this.errorDescription = '';
    let self = this;
    this.itemApi.addPolygonToItem(
      { 
        polygon: this.polygonCoords,
        updated: this.polygonReallyModified
      }
    ).then((response) => {
      // Algunos backends no devuelven cuerpo en el PATCH: sin `redirect_url` se usa la del GET.
      let redirectUrl = (response && response.redirect_url) || null;
      self.redirectAction(redirectUrl);
      this.success = true;
      this.dialogTitle = this.successMessage;
    }).catch((error) => {
      this.error = true;
      this.errorDescription = error && error.response && error.response.data && error.response.data.message ? error.response.data.message : '';
      this.dialogTitle = this.errorMessage;
    }).finally(() => {
      this.loading = false;
    });
  }

  closeItem(){
    if(window.confirm('¿Desea salir del Item?')) {
        this.redirectAction(null);
    }
  }

  closeDialog() {
    this.dialog = false;
    this.resetDialog();
  }

  resetDialog() {
    this.loading = false;
    this.success = false;
    this.error = false;
    this.dialogTitle = '';
  }

  @Emit()
  showMessage(message: string, color: string) {}
}
